module.exports = __webpack_public_path__ + "ms.svg?cf3834795e20c72c4e0b8ab277b34534";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ms.svg
// module id = 1327
// module chunks = 27